// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpeedBuildings_service-page__jqY1t{
    display: flex;
    flex-direction: column;
    gap: 40px;
}
/* .service-page__title{
    font-size: var(--font-size-4xl);
    font-weight: var(--font-bold);
} */`, "",{"version":3,"sources":["webpack://./src/pages/Services/SpeedBuildings/SpeedBuildings.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;;;GAGG","sourcesContent":[".service-page{\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n}\n/* .service-page__title{\n    font-size: var(--font-size-4xl);\n    font-weight: var(--font-bold);\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"service-page": `SpeedBuildings_service-page__jqY1t`
};
export default ___CSS_LOADER_EXPORT___;
